

import Weather from './Weather';

function App() {
  return (
    <div>
      <Weather></Weather>
    </div>
  );
}

export default App;
